import { ReactNode } from 'react';

import { Divider } from '@/components/atoms/Divider/Divider';
import { Title } from '@/components/atoms/Title/Title';

import Box from '@mui/material/Box';
import { sp } from '@/theme/mui';
import Stack from '@mui/material/Stack';

interface CareProviderProfileSectionProps {
  title?: string;
  description?: string;
  children?: ReactNode;
  isDivider?: boolean;
}
export function CareProviderProfileSection({
  title,
  description,
  children,
  isDivider = true,
}: CareProviderProfileSectionProps) {
  return (
    <Stack sx={{ gap: sp[32] }}>
      {title && (
        <Title size='sm' isNoMargin>
          {title}
        </Title>
      )}
      {description && <Box sx={{ typography: 'bodyMd' }}>{description}</Box>}
      <>
        {children}
        {isDivider && <Divider isOr={false} margin={16} />}
      </>
    </Stack>
  );
}

export default CareProviderProfileSection;
